import { SvgIcon } from '@/components/UI/Common/SvgIcon';
import ChatsListItem from './ChatsListItem';
import { Chat } from '@/types/chats';
import cn from 'classnames';
import { useParams } from 'react-router-dom';

interface ChatsGroupProps {
  isExpanded: boolean;
  groupTitle: string;
  chats: Chat[];
  onToggle: VoidFunction;
  isExpandedBySearch?: boolean;
}
const ChatsGroup = ({
  isExpanded,
  onToggle,
  groupTitle,
  chats,
  isExpandedBySearch = false,
}: ChatsGroupProps) => {
  const { chatId } = useParams();
  const hasActiveChat = chatId ? chats.some((chat) => chat.id === chatId) : false;
  const isGroupOpen = hasActiveChat || isExpandedBySearch || isExpanded;
  const hasUnread = chats.some((chat) => chat.unreadCount > 0);

  return (
    <div id="chats-group">
      <div
        onClick={onToggle}
        className={cn(
          'flex cursor-pointer items-center justify-between border-b border-lightGray px-4 py-4 text-xl font-medium transition-colors duration-200 hover:text-brand-primary md:py-2 md:pl-4 md:pr-4 md:text-xs md:font-semibold md:uppercase md:tracking-wide xl:px-5',
          isGroupOpen ? 'text-black' : 'text-lightGray',
        )}
      >
        <div className="flex min-w-0 items-center gap-2">
          <span className="md:truncate">{groupTitle}</span>
          {hasUnread && <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-brand-primary" />}
        </div>
        <SvgIcon
          className={cn('shrink-0 md:scale-75', isGroupOpen ? 'rotate-180' : '')}
          name="arrow-down"
          size={24}
        />
      </div>
      {isGroupOpen && (
        <div className="">
          {chats.map((chat) => (
            <ChatsListItem key={chat.id} chat={chat} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ChatsGroup;
